import React from 'react';
import {connect} from 'react-redux';
import {reduxForm} from 'redux-form';
import ErrorBlock from 'components/ErrorBlock';

import {roomInspectionPass} from 'ducks/frontDesk';

import './styles.css';

const onSubmit = (_values, dispatch, props) => {
  const {locationRef, bookingId, allocationId, getExtraActions} = props;

  dispatch(
    roomInspectionPass(
      {locationRef, bookingId, allocationId},
      getExtraActions()
    )
  );
};

const RoomInspectionPassForm = ({error}) => (
  <form className="RoomInspectionPassForm">
    {error && <ErrorBlock>{error}</ErrorBlock>}
    <div className="confirmationQuestion">
      Are you sure you want to pass the inspection for this room?
    </div>
  </form>
);

const roomInspectionPassForm = reduxForm({
  form: 'roomInspectionPass',
  onSubmit: onSubmit
})(RoomInspectionPassForm);

export default connect()(roomInspectionPassForm);
